/* ============================================================
   CiemnaSzyba — rdzeń
   Zamiennik komponentu React z Claude Design. Bez frameworka,
   bez zależności. ~2 KB.
   ============================================================ */
(function () {
  "use strict";

  /* Jedno źródło prawdy dla breakpointu. W źródle było ich dwa:
     @media (max-width:900px) w CSS i window.innerWidth < 900 w JS. */
  var mobileMQ = window.matchMedia("(max-width: 899.98px)");

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---- store -------------------------------------------------
     Płytki merge + powiadomienie. Każdy subskrybent obsługuje
     ROZŁĄCZNY fragment DOM i robi chirurgiczne update'y, więc
     nie ma czego diffować. */
  function createStore(initial) {
    var state = Object.assign({}, initial);
    var subs = [];
    return {
      get: function () { return state; },
      set: function (patch) {
        var next = Object.assign({}, state, patch);
        var changed = false;
        for (var k in next) { if (next[k] !== state[k]) { changed = true; break; } }
        if (!changed) return;
        state = next;
        for (var i = 0; i < subs.length; i++) subs[i](state);
      },
      subscribe: function (fn) { subs.push(fn); return function () { subs = subs.filter(function (s) { return s !== fn; }); }; }
    };
  }

  /* ---- pieniądze ---------------------------------------------
     Implementacja tokenów Shopify. Format PRZYCHODZI Z LIQUID
     (data-money-format), nigdy nie jest zaszyty w kodzie.
     Źródłowe `n.toLocaleString('pl-PL') + ' zł'` zgadzało się
     przypadkiem i pękłoby przy pierwszej zmianie waluty. */
  function groupBy(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function formatMoney(cents, format) {
    var fmt = format || "{{amount}}";
    var value = (Number(cents) || 0) / 100;

    function build(decimals, thousandSep, decimalSep) {
      var fixed = value.toFixed(decimals);
      var parts = fixed.split(".");
      var out = groupBy(parts[0], thousandSep);
      if (decimals > 0 && parts[1]) out += decimalSep + parts[1];
      return out;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case "amount":                                   return build(2, ",", ".");
        case "amount_no_decimals":                       return build(0, ",", ".");
        case "amount_with_comma_separator":              return build(2, ".", ",");
        case "amount_no_decimals_with_comma_separator":  return build(0, ".", ",");
        case "amount_with_apostrophe_separator":         return build(2, "'", ".");
        case "amount_with_space_separator":              return build(2, " ", ",");
        case "amount_no_decimals_with_space_separator":  return build(0, " ", ",");
        default:                                         return build(2, ",", ".");
      }
    });
  }

  /* ---- cykl życia sekcji -------------------------------------
     ⚠ Bez tego każda edycja w edytorze motywu zostawia martwy
     konfigurator — najczęstszy błąd ręcznych portów na OS 2.0.
     Sekcja przeładowana przez edytor musi się od-inicjalizować
     (posprzątać listenery/timery) i zainicjalizować na nowo. */
  var registry = [];

  function onSection(selector, init) {
    registry.push({ selector: selector, init: init });
    $$(selector).forEach(function (el) { mount(selector, init, el); });
  }

  var mounted = new WeakMap();

  function mount(selector, init, el) {
    if (mounted.has(el)) return;
    var teardown = init(el) || function () {};
    mounted.set(el, teardown);
  }

  function unmount(el) {
    var teardown = mounted.get(el);
    if (teardown) { try { teardown(); } catch (e) { /* nieistotne przy zdejmowaniu */ } }
    mounted.delete(el);
  }

  document.addEventListener("shopify:section:load", function (e) {
    registry.forEach(function (r) {
      $$(r.selector, e.target).forEach(function (el) { mount(r.selector, r.init, el); });
      if (e.target.matches && e.target.matches(r.selector)) mount(r.selector, r.init, e.target);
    });
  });

  document.addEventListener("shopify:section:unload", function (e) {
    $$("*", e.target).forEach(unmount);
    unmount(e.target);
  });

  /* ---- i18n ---------------------------------------------------
     Stringi widoczne dla klienta, które musi znać JS, przychodzą z Liquida
     przez `snippets/cs-i18n.liquid` jako <script type="application/json">.
     Parsujemy raz, na starcie.

     ⚠ Bez `fetch` i bez drugiej ścieżki. Blok stoi w <head> przed skryptami,
     a te są `defer`, więc w momencie wykonania tego pliku jest już w DOM.
     ⚠ `CS.t` ZAWSZE ma zapas: gdyby snippet zniknął albo klucz nie istniał,
     interfejs pokazuje wartość polską zamiast pustki. Brak klucza to błąd
     do naprawienia w locale, nie powód do wywalenia strony. */
  var I18N = (function () {
    try {
      var el = document.getElementById("cs-i18n");
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      console.error("[cs] nie udało się sparsować cs-i18n", e);
      return {};
    }
  })();

  function t(klucz, zapas) {
    var w = I18N;
    var czesci = String(klucz).split(".");
    for (var i = 0; i < czesci.length; i++) {
      if (w == null || typeof w !== "object") return zapas;
      w = w[czesci[i]];
    }
    return typeof w === "string" && w !== "" ? w : zapas;
  }

  /* ---- publiczne --------------------------------------------- */
  window.CS = {
    t: t,
    $: $,
    $$: $$,
    mobileMQ: mobileMQ,
    isMobile: function () { return mobileMQ.matches; },
    createStore: createStore,
    formatMoney: formatMoney,
    onSection: onSection,

    /* Toast — w Design sterowany <sc-if value="{{ toastVisible }}">. */
    toast: function (msg) {
      var el = $("[data-cs-toast]");
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
      clearTimeout(el._t);
      el._t = setTimeout(function () { el.hidden = true; }, 3600);
    }
  };
})();
